import { connect } from 'react-redux';
import LiveAuctionsManager from 'components/auctions/LiveAuctionsManager';
import {
  fetchOnlineAuctions,
  notifyLiveAuctionBid,
  notifyLiveAuctionEnd,
  notifyLiveAuctionStart,
} from 'data/auctions/Auctions.actions';
import { showOnline } from 'data/app/App.actions';

const mapStateToProps = ({ app }) => ({
  partyType:
    app.user && app.lookups
      ? app.lookups.partyTypes.find(p => p.ID === app.user.PartyType)
      : null,
  showOnline: app.showOnline,
});
const mapDispatchToProps = dispatch => ({
  fetchOnlineAuctions: () => dispatch(fetchOnlineAuctions()),
  onLiveAuctionEnded: auction => dispatch(notifyLiveAuctionEnd(auction)),
  onLiveAuctionOutbid: data => dispatch(notifyLiveAuctionBid(data)),
  onLiveAuctionStarted: auction => dispatch(notifyLiveAuctionStart(auction)),
  setShowOnline: visible => dispatch(showOnline(visible)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveAuctionsManager);
